<template>
  <b-container>
    <b-card>
      <b-form @submit="saveChanges">
        <b-row>
          <b-col sm="12">
            <b-form-group
              label="Web Link"
              label-for="weblink"
            >
              <b-form-input
                id="weblink"
                v-model="weblink"
              />
            </b-form-group>
          </b-col>
          <b-col class="d-flex justify-content-end">
            <b-button
              type="button"
              class="mr-1"
              variant="light"
            >
              Cancel
            </b-button>
            <b-button
              type="submit"
              :disabled="isLoading"
              variant="primary"
            >
              Save
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
import {
  BRow, BCol, BContainer, BFormGroup, BCard, BFormInput, BButton, BForm,
} from 'bootstrap-vue'

export default {
  components: {
    BRow, BCol, BContainer, BFormGroup, BCard, BFormInput, BButton, BForm,
  },

  data() {
    return {
      isLoading: false,
      weblink: '',
    }
  },

  mounted() {
    this.fetchSettings()
  },

  methods: {
    fetchSettings() {
      this.$http.get('/settings/apps-link')
        .then(res => {
          this.weblink = res.data.data.web_link
        })
        .catch(err => { this.$notif('Error', `${err.message}`, 'error') })
    },

    saveChanges(event) {
      event.preventDefault()
      this.isLoading = true

      this.$http.post('/settings/apps-link', {
        web_link: this.weblink,
      })
        .then(() => {
          this.$notif('Success', 'Apps Link settings has been successfully updated.', 'success')
          this.fetchSettings()
        })
        .catch(err => { this.$notif('Error', `${err.message}`, 'error') })
        .finally(() => { this.isLoading = false })
    },
  },
}
</script>
